import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import styled from "styled-components";
import Fade from '@material-ui/core/Fade';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MetricSelection from './MetricSelection';
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import _ from 'lodash';

const MetricsSelected = styled.div`
  && {
    font-size:17px;  
    padding-left:20px;
    margin:0;
  }
`
const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom:20px;
`;
const Spacer = styled.div`
  flex-grow:1;
`

const Error = styled.div`
  color:#ff0000;
  font-size:17px;
  padding-left:8px;
`

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
  `
class SelectMetricsStep extends React.Component {
  state = {
    shouldShowError: false
  }

  selectionErrorMessageUnderMax = {
    metric: `You must choose ${this.maxCount} metrics for your top bar.`,
    column: `You must choose ${this.maxCount} columns.`
  }
  selectionErrorMessageOverMax = {
    metric: `You have already selected ${this.maxCount} metrics.`,
    column: `You have already selected ${this.maxCount} columns.`
  }
  dialogDescription = {
    metric: `Select the (${this.maxCount}) metrics you would like to see displayed at the top of your screen`,
    column: `Select the (${this.maxCount}) columns you would like to see displayed on this table`
  }

  get maxCount() { 
    let maxCount = this.props.maxCount || 6; 
    const availableMetrics = this.props.metrics.length;
    return _.min([maxCount, availableMetrics])
  }
  get dialogType() { return this.props.isMetric ? "metric" : "column" }
  close = () => { this.props.handleClose(); }

  next = (activeStep) => {
    const { metrics } = this.props;
    if (this.getSelectedMetricCount() < this.maxCount) {
      this.setState({
        shouldShowError: true,
        selectionErrorMessage: this.selectionErrorMessageUnderMax[this.dialogType]
      })
      return null;
    }
    this.props.handleNext(activeStep, metrics)
  }

  getSelectedMetricCount = () => {
    return this.props.metrics.filter(x => x.isSelected).length;
  }

  isElementSelected = (elementId) => {
    const { metrics } = this.props;
    let index = metrics.findIndex(x => x.screenElementId === elementId);
    return metrics[index].isSelected;
  }

  onToggle = (elementId) => {
    if (!this.isElementSelected(elementId) && this.getSelectedMetricCount() == this.maxCount) {
      this.setState({
        shouldShowError: true,
        selectionErrorMessage: this.selectionErrorMessageOverMax[this.dialogType]
      })
    } else {
      this.setState({ shouldShowError: false })
      this.props.onToggle(elementId);
    }
  }
  sortByTitleAlphabetically = (a, b) => {
    if (a.title < b.title) { return -1; }
    if (a.title > b.title) { return 1; }
    return 0;
  }
  renderMetrics = metrics => (
    <GridList cellHeight='auto' cols={3} spacing={4}>
      {
        metrics.sort(this.sortByTitleAlphabetically).map(x => (
          <GridListTile key={x.screenElementId}>
            <MetricSelection
              metric={x}
              toggle={this.onToggle}>
            </MetricSelection>
          </GridListTile>
        ))
      }
    </GridList>
  );

  render() {
    const { activeStep, handleNext, metrics } = this.props;
    let { shouldShowError, selectionErrorMessage } = this.state;

    if (_.isEmpty(metrics))
      return null;
    return (
      <React.Fragment>
        <DialogContent>
          <Description>{this.dialogDescription[this.dialogType]}</Description>
          {this.renderMetrics(metrics)}
        </DialogContent>
        <StyledDialogActions>
          <MetricsSelected>{this.getSelectedMetricCount()}/{this.maxCount} Selected</MetricsSelected>
          <Fade in={shouldShowError}>
            <Error>{selectionErrorMessage}</Error>
          </Fade>
          <Spacer></Spacer>
          <Fragment>
            <Button onClick={this.close} color="primary">Cancel</Button>
            <Button onClick={() => this.next(activeStep)} color="primary">Next</Button>
          </Fragment>
        </StyledDialogActions>
      </React.Fragment>
    );
  }
}

export default SelectMetricsStep;
